import { render, staticRenderFns } from "./audition.vue?vue&type=template&id=988e22b4&scoped=true&"
import script from "./audition.vue?vue&type=script&lang=js&"
export * from "./audition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988e22b4",
  null
  
)

export default component.exports